import * as React from "react";
import { Badge } from "../primitive/badge";
import { cn } from "../lib/utils";

export function StatusChip({
  status,
  children,
}: {
  status: "active" | "pending" | "error";
  children: React.ReactNode;
}) {
  // Keep status semantics in the wrapper so the shared Badge primitive can stay aligned with upstream shadcn nova.
  return (
    <Badge
      variant={status === "error" ? "destructive" : status === "pending" ? "secondary" : "outline"}
      className={cn(
        status === "active" && "border-primary/25 bg-primary/10 text-primary",
        status === "pending" && "bg-secondary text-secondary-foreground",
      )}
    >
      {children}
    </Badge>
  );
}
